import { NgClass } from '@angular/common';
import { Component, EventEmitter, HostBinding, Input, Output, ViewEncapsulation } from '@angular/core';
import { ClickOutsideDirective } from 'src/app/directive/click-outside.directive';

@Component({
  selector: 'app-button',
  imports: [NgClass, ClickOutsideDirective],
  templateUrl: './button.component.html',
  styleUrl: './button.component.scss',
  // encapsulation: ViewEncapsulation.None,
  // host: {
  //   'class': 'hostClass',
  // },
})
export class ButtonComponent {
  @Input() type = 'button';
  @Input() classes: string[] = [];
  @Input() disabled = false;
  @Input() loading = false;
  @Input()
  @HostBinding('style.display')
  hostDisplay: ButtonHostDisplay = 'inline-flex';
  @Output() buttonClick = new EventEmitter<MouseEvent>();
  @Output() clickOutside = new EventEmitter<Event>();

  buttonClickFn(event: MouseEvent): void {
    this.buttonClick.emit(event);
  }

  clickedOutside(event: Event): void {
    this.clickOutside.emit(event);
  }

  // get hostClass(): string {
  //   return `app-button-host app-button-host--${this.hostDisplay}`;
  // }
}

type ButtonHostDisplay =
  | 'contents'
  | 'block'
  | 'inline-block'
  | 'flex'
  | 'inline-flex';